import { deepMix, each, filter, get } from '@antv/util';
import { AxisCfg, CircleCfg, CircleData, Datum } from '../interface';

import View from '../chart/view';
import { DIRECTION } from '../constant';
import { getAnglePoint, getFactTitleConfig } from '../util/facet';
import { Facet } from './facet';

/**
 * @ignore
 * éååé¢
 */
export default class Circle extends Facet<CircleCfg, CircleData> {
  protected getDefaultCfg() {
    return deepMix({}, super.getDefaultCfg(), {
      type: 'circle',
      showTitle: true,
      title: super.getDefaultTitleCfg(),
    });
  }

  public render() {
    super.render();

    if (this.cfg.showTitle) {
      this.renderTitle();
    }
  }

  /**
   * æ ¹æ®æ»æ°åå½åç´¢å¼ï¼è®¡ç®åé¢ç region
   * @param count
   * @param index
   */
  protected getRegion(count: number, index: number) {
    const r = 1 / 2; // ç»å¸åå¾
    // ç»å¸åå¿
    const center = { x: 0.5, y: 0.5 };
    // æ¯éåé¢é´éçå¼§åº¦
    const avgAngle = (Math.PI * 2) / count;

    // å½ååé¢æå¨çå¼§åº¦
    const angle = (-1 * Math.PI) / 2 + avgAngle * index;
    // TODO æ²¡çæ
    const facetR = r / (1 + 1 / Math.sin(avgAngle / 2));
    // åé¢çä¸­å¿ç¹
    const middle = getAnglePoint(center, r - facetR, angle);
    const startAngle = (Math.PI * 5) / 4; // å³ä¸è§
    const endAngle = (Math.PI * 1) / 4; // å·¦ä¸è§

    return {
      start: getAnglePoint(middle, facetR, startAngle),
      end: getAnglePoint(middle, facetR, endAngle),
    };
  }

  protected afterEachView(view: View, facet: CircleData) {
    this.processAxis(view, facet);
  }

  protected beforeEachView(view: View, facet: CircleData) {}

  protected generateFacets(data: Datum[]): CircleData[] {
    const { fields, type } = this.cfg;
    const [field] = fields;
    if (!field) {
      throw new Error('No `fields` specified!');
    }

    const values = this.getFieldValues(data, field);
    const count = values.length;

    const rst = [];
    values.forEach((value: any, index: number) => {
      const conditions = [{ field, value, values }];
      const facetData = filter(data, this.getFacetDataFilter(conditions));

      const facet: CircleData = {
        type,
        data: facetData,
        region: this.getRegion(count, index),

        columnValue: value,
        columnField: field,
        columnIndex: index,
        columnValuesLength: count,

        rowValue: null,
        rowField: null,
        rowIndex: 0,
        rowValuesLength: 1,
      };
      rst.push(facet);
    });
    return rst;
  }

  protected getXAxisOption(x: string, axes: any, option: AxisCfg, facet: CircleData): object {
    // ä¸åä»»ä½å¤ç
    return option;
  }

  /**
   * è®¾ç½® y åæ è½´çææ¬ãtitle æ¯å¦æ¾ç¤º
   * @param y
   * @param axes
   * @param option
   * @param facet
   */
  protected getYAxisOption(y: string, axes: any, option: AxisCfg, facet: CircleData): object {
    // ä¸åä»»ä½å¤ç
    return option;
  }

  /**
   * facet title
   */
  private renderTitle() {
    each(this.facets, (facet: CircleData) => {
      const { columnValue, view } = facet;
      const formatter = get(this.cfg.title, 'formatter');

      const config = deepMix(
        {
          position: ['50%', '0%'] as [string, string],
          content: formatter ? formatter(columnValue) : columnValue,
        },
        getFactTitleConfig(DIRECTION.TOP),
        this.cfg.title
      );

      view.annotation().text(config);
    });
  }
}
